import { supabase } from "@/lib/supabase";

export type LoadoutSyncEvent = "loadout.created" | "loadout.updated";

export interface TriggerLoadoutPushResult {
  ok: boolean;
  skipped?: boolean;
  reason?: string;
  error?: string;
  idempotencyKey?: string;
  state?: string;
  itemCount?: number;
}

/**
 * Triggers the loadout-sync-push edge function, which builds the loadout
 * manifest from job_materials and POSTs it to the Portal.
 *
 * This is fire-and-forget on the primary write path — always call with `void`.
 * Failures are logged to loadout_sync_log; they never surface to the UI.
 */
export const LoadoutSyncService = {
  async triggerLoadoutPush(
    jobId: string,
    event: LoadoutSyncEvent,
  ): Promise<TriggerLoadoutPushResult> {
    try {
      const { data, error } = await supabase.functions.invoke<
        TriggerLoadoutPushResult | { error: string }
      >("loadout-sync-push", { body: { jobId, event } });

      if (error) {
        console.error("[LoadoutSyncService] Edge function error:", error.message);
        return { ok: false, error: error.message };
      }

      return (data as TriggerLoadoutPushResult) ?? { ok: false, error: "empty_response" };
    } catch (err) {
      const msg = err instanceof Error ? err.message : String(err);
      console.error("[LoadoutSyncService] Exception:", msg);
      return { ok: false, error: msg };
    }
  },
};
